import styled from 'styled-components';

export const Wrapper = styled.h2`
  margin: 0;
  padding-bottom: 25px;
  border-bottom: 3px solid #000;
  margin-bottom: 20px;

  font-size: 1.5em;
  font-weight: 300;

  display: flex;
  justify-content: space-between;

  button {
    color: #6896c8;
    margin-bottom: -10px;
  }
`;
